var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _setup.formId
        ? _c(_setup.Form, {
            key: _setup.formId,
            attrs: {
              id: _setup.id,
              "form-id": _setup.formId,
              "show-legends": false,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "footer",
        { staticClass: "text-center mt-3 mb-3" },
        [
          _c(_setup.FormSaveBtn, {
            attrs: {
              "button-text": "Save",
              "cancel-on-save": true,
              "form-id": _setup.formId,
              "default-btn-class": "btn-secondary",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }